module.exports = __webpack_public_path__ + "img/client-logo-2.063615fe.png";